module.exports = __webpack_public_path__ + "media/images/icon-exit-gray-57ad8d3f2c6e6c7151ffae92446c3bdd.svg";